import React, { useEffect, useRef } from 'react';
import { Chart, BarElement, CategoryScale, LinearScale, Tooltip, Legend, ChartData, ChartOptions } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS } from 'react-chartjs-2';
import { formatLargeNumber } from '../../core/utils/funcoes';
import { FiltroSopSales } from '../../core/repositories/sopSalesRepositorio';


const SopProductionGrowthChart: React.FC<{ filtro: FiltroSopSales }> = (props) => {
    const data = {
        labels: ['Dec/2024', 'Jan/2025', 'Feb/2025', 'Mar/2025', 'Apr/2025'],
        datasets: [
            {
                label: 'Cost',
                data: [12000, 14000, 13500, 15000, 16500],
                backgroundColor: '#2196F3',
                borderRadius: 4,
                barThickness: 18,
            },
            {
                label: 'Revenue',
                data: [11500, 13800, 13000, 14200, 16800],
                backgroundColor: (context: { dataIndex: any; }) => {
                    const index = context.dataIndex;
                    return index === 4 ? '#90CAF9' : '#90CAF9'; // verde pra última
                },
                borderRadius: 4,
                barThickness: 18,
            },
        ],
    }
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            tooltip: {
                callbacks: {
                    label: (context: any) => {
                        return `${context.dataset.label}: $${context.raw.toLocaleString()}`;
                    },
                },
            },
            legend: {
                labels: {
                    font: { size: 13 },
                },
            },
        },
        scales: {
            x: {
                grid: { display: false },
                ticks: { font: { size: 12 } },
            },
            y: {
                ticks: {
                    callback: (value: { toLocaleString: () => any; }) => `$${value.toLocaleString()}`,
                    font: { size: 12 },
                },
                beginAtZero: true,
            },
        },
    }

    return (
        <div className="card p-3 shadow-sm border-0" style={{ height: '250px' }}>
            <strong className="title-card mb-2">Revenue vs. Cost</strong>
            <div style={{ height: '100%' }}>
                <Bar data={data} options={options}></Bar>
            </div>
        </div>
    );

    
};

export default SopProductionGrowthChart;
